var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4106_5184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4075 0.5H0.5V17.5H15.4075V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4106_5184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9279 16.8196C11.9683 17.7138 10.9095 17.5744 9.90036 17.1528C8.82744 16.7227 7.84659 16.6955 6.71347 17.1528C5.30239 17.7376 4.55347 17.5676 3.70364 16.8196C-1.09439 12.0766 -0.386197 4.8516 5.06692 4.5796C6.38947 4.6476 7.31544 5.2817 8.09446 5.3344C9.25236 5.1083 10.3607 4.4606 11.6 4.5456C13.089 4.6612 14.2027 5.2256 14.9463 6.2405C11.8833 8.0085 12.6092 11.8845 15.4226 12.9725C14.8595 14.392 14.1371 15.7945 12.9262 16.8315L12.9279 16.8196ZM7.98823 4.5286C7.84482 2.4206 9.62416 0.686602 11.6709 0.516602C11.9524 2.9476 9.36921 4.7666 7.98823 4.5286Z",
    fill: "#282119"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.da254989cf7c084139376fded2722d75.svg";
export { ForwardRef as ReactComponent };